export const featuredArticles = [
  {
    id: 'article-1',
    slug: 'dingri-jinjing-tafang',
    title: '顶流网红直播翻车，人设崩塌现场全记录',
    excerpt: '某千万粉丝顶流网红在直播中意外暴露真实面目，前后人设反差巨大，网友直呼"滤镜碎了"……',
    category: '网红塌房',
    categorySlug: 'wanghong-tafang',
    imageUrl: 'https://readdy.ai/api/search-image?query=Shocked%20internet%20celebrity%20live%20streaming%20accident%20moment%2C%20dramatic%20lighting%20with%20warm%20and%20dark%20contrast%2C%20cinematic%20photography%20style%2C%20emotional%20expression%2C%20soft%20bokeh%20background%20with%20modern%20studio%20setting%2C%20high%20detail%20editorial%20shot&width=800&height=1067&seq=featured-article-01&orientation=portrait',
    date: '2026-07-06',
    views: 128000,
    tag: '爆',
    tagColor: 'bg-primary-500',
  },
  {
    id: 'article-2',
    slug: 'xuanxiu-jimu-heiliao',
    title: '选秀节目黑幕大揭秘：导师暗箱操作实锤',
    excerpt: '知情人士曝光某选秀节目内幕，导师提前内定晋级名额，选手机场痛哭……',
    category: '选秀黑幕',
    categorySlug: 'xuanxiu-heimu',
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20backstage%20dramatic%20moment%2C%20contestant%20emotional%20breakdown%20under%20stage%20lights%2C%20dark%20atmosphere%20with%20spotlight%20contrast%2C%20theatrical%20drama%20photography%20with%20warm%20amber%20lighting%2C%20cinematic%20composition%20with%20shallow%20depth%20of%20field&width=800&height=1067&seq=featured-article-02&orientation=portrait',
    date: '2026-07-05',
    views: 96000,
    tag: '热',
    tagColor: 'bg-accent-500',
  },
  {
    id: 'article-3',
    slug: 'zhibo-daihuo-jiahuo',
    title: '知名主播带货翻车，假货风波持续发酵',
    excerpt: '消费者集体投诉某大主播售卖假冒伪劣产品，品牌方紧急发声撇清关系……',
    category: '直播爆料',
    categorySlug: 'zhibo-baoliao',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20shopping%20scandal%20moment%2C%20influencer%20holding%20product%20with%20shocked%20expression%2C%20dramatic%20studio%20lighting%20with%20red%20and%20warm%20tones%2C%20controversial%20atmosphere%2C%20editorial%20photography%20style%20with%20soft%20shadows%20and%20clean%20background&width=800&height=1067&seq=featured-article-03&orientation=portrait',
    date: '2026-07-04',
    views: 85000,
    tag: '新',
    tagColor: 'bg-secondary-500',
  },
];

export const categoryCards = [
  {
    id: 'cat-1',
    title: '网红塌房',
    slug: 'wanghong-tafang',
    description: '网红人设崩塌、翻车现场',
    imageUrl: 'https://readdy.ai/api/search-image?query=Internet%20celebrity%20scandal%20concept%2C%20broken%20pedestal%20with%20dramatic%20lighting%2C%20warm%20pinkish%20tone%20background%2C%20artistic%20minimalist%20composition%2C%20soft%20diffused%20light%20with%20gentle%20shadows%2C%20editorial%20fashion%20magazine%20style&width=600&height=800&seq=category-card-01&orientation=portrait',
    color: 'bg-[#f5e6e0]',
  },
  {
    id: 'cat-2',
    title: '选秀黑幕',
    slug: 'xuanxiu-heimu',
    description: '综艺选秀背后的故事',
    imageUrl: 'https://readdy.ai/api/search-image?query=Talent%20show%20behind%20the%20scenes%20drama%2C%20dark%20backstage%20with%20spotlight%2C%20mint%20green%20atmospheric%20tone%2C%20mysterious%20cinematic%20composition%2C%20soft%20dramatic%20lighting%20with%20dreamy%20effect%2C%20artistic%20photography&width=600&height=800&seq=category-card-02&orientation=portrait',
    color: 'bg-[#e0ece4]',
  },
  {
    id: 'cat-3',
    title: '综艺翻车',
    slug: 'zongyi-fanche',
    description: '综艺节目尴尬名场面',
    imageUrl: 'https://readdy.ai/api/search-image?query=Variety%20show%20awkward%20moment%20on%20stage%2C%20embarrassed%20celebrity%20expression%2C%20warm%20beige%20neutral%20background%20tone%2C%20soft%20natural%20lighting%20with%20gentle%20highlights%2C%20editorial%20photography%20style%20with%20clean%20composition&width=600&height=800&seq=category-card-03&orientation=portrait',
    color: 'bg-[#f0ebe3]',
  },
  {
    id: 'cat-4',
    title: '直播爆料',
    slug: 'zhibo-baoliao',
    description: '直播间里的精彩瞬间',
    imageUrl: 'https://readdy.ai/api/search-image?query=Live%20streaming%20room%20dramatic%20scene%2C%20streamer%20shocked%20face%20reaction%2C%20warm%20amber%20golden%20tone%20atmosphere%2C%20soft%20cinematic%20lighting%20with%20bokeh%20effect%2C%20editorial%20photography%20with%20artistic%20composition&width=600&height=800&seq=category-card-04&orientation=portrait',
    color: 'bg-[#f5efe0]',
  },
];

export const hotArticles = [
  {
    id: 'hot-1',
    slug: 'duanzi-shou-mimi-jiehun',
    title: '某知名短剧博主被曝秘密结婚，粉丝集体脱粉',
    excerpt: '粉丝发现细节线索，顺藤摸瓜挖出隐婚实锤……',
    category: '网红塌房',
    date: '2026-07-07',
    views: 67000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Secret%20wedding%20scandal%20concept%2C%20dramatic%20reveal%20moment%20with%20wedding%20ring%20focus%2C%20warm%20intimate%20lighting%20with%20soft%20shadows%2C%20emotional%20atmosphere%2C%20editorial%20photography%20style%20with%20clean%20minimalist%20composition&width=600&height=400&seq=hot-article-01&orientation=landscape',
  },
  {
    id: 'hot-2',
    slug: 'meizhuang-bozhu-choushi',
    title: '美妆博主素颜出镜惊呆众人，前后差距引争议',
    excerpt: '百万粉丝美妆博主力证"化妆如换头"……',
    category: '直播爆料',
    date: '2026-07-06',
    views: 54000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Beauty%20influencer%20before%20and%20after%20makeup%20comparison%2C%20dramatic%20transformation%20concept%2C%20soft%20natural%20lighting%20with%20clean%20studio%20background%2C%20editorial%20beauty%20photography%20style%2C%20minimalist%20composition%20with%20gentle%20contrast&width=600&height=400&seq=hot-article-02&orientation=landscape',
  },
  {
    id: 'hot-3',
    slug: 'yinyue-ren-jiechou',
    title: '知名音乐人被扒抄袭，多首热门歌曲涉嫌侵权',
    excerpt: '网友逐帧对比扒谱，证据链完整令人震惊……',
    category: '选秀黑幕',
    date: '2026-07-05',
    views: 43000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Music%20plagiarism%20controversy%20concept%2C%20sheet%20music%20comparison%20with%20dramatic%20lighting%2C%20dark%20moody%20atmosphere%20with%20warm%20accents%2C%20editorial%20documentary%20photography%20style%2C%20clean%20composition%20with%20mysterious%20tone&width=600&height=400&seq=hot-article-03&orientation=landscape',
  },
  {
    id: 'hot-4',
    slug: 'yundong-bozhu-zuobi',
    title: '健身博主被指使用药物，科学分析揭秘真相',
    excerpt: '专业人士从训练痕迹、肌肉形态等角度深度分析……',
    category: '网红塌房',
    date: '2026-07-04',
    views: 38000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Fitness%20influencer%20controversy%20concept%2C%20gym%20setting%20with%20dramatic%20contrast%20lighting%2C%20athletic%20atmosphere%20with%20warm%20tones%2C%20editorial%20sports%20photography%20style%2C%20clean%20minimalist%20composition%20with%20depth&width=600&height=400&seq=hot-article-04&orientation=landscape',
  },
  {
    id: 'hot-5',
    slug: 'zhibozhu-shuijue',
    title: '主播直播中睡着引百万人围观，醒来反应绝了',
    excerpt: '熬夜直播的主播意外睡着，直播间人气不降反升……',
    category: '直播爆料',
    date: '2026-07-03',
    views: 32000,
    imageUrl: 'https://readdy.ai/api/search-image?query=Streamer%20falling%20asleep%20during%20live%20broadcast%2C%20funny%20unexpected%20moment%2C%20dim%20warm%20room%20lighting%20with%20monitor%20glow%2C%20candid%20documentary%20photography%20style%2C%20cozy%20atmosphere%20with%20soft%20shadows&width=600&height=400&seq=hot-article-05&orientation=landscape',
  },
  {
    id: 'hot-6',
    slug: 'yishujia-zhaopian',
    title: '某艺术家被指作品全是AI生成，收藏圈地震',
    excerpt: '数字艺术圈惊爆丑闻，数千万交易额恐成泡沫……',
    category: '综艺翻车',
    date: '2026-07-02',
    views: 29000,
    imageUrl: 'https://readdy.ai/api/search-image?query=AI%20art%20controversy%20scandal%20concept%2C%20digital%20art%20display%20with%20dramatic%20gallery%20lighting%2C%20futuristic%20yet%20dark%20moody%20atmosphere%2C%20editorial%20conceptual%20photography%20style%2C%20clean%20composition%20with%20warm%20and%20cool%20contrast&width=600&height=400&seq=hot-article-06&orientation=landscape',
  },
];

export const timelineData = [
  { date: '2026.07', title: '平台成立', description: '每日大赛黑料网正式上线' },
  { date: '2026.07', title: '首破10万', description: '单日访问量突破10万' },
  { date: '2026.08', title: '百万粉丝', description: '全网粉丝突破100万' },
  { date: '2026.09', title: '内容升级', description: '引入视频爆料新模式' },
];

export const brandValues = [
  { icon: 'ri-shield-flash-line', label: '一手爆料' },
  { icon: 'ri-timer-flash-line', label: '每日更新' },
  { icon: 'ri-emotion-happy-line', label: '真实可靠' },
  { icon: 'ri-group-line', label: '吃瓜社区' },
  { icon: 'ri-eye-line', label: '透明公开' },
];

export const testimonials = [
  {
    id: 't-1',
    name: '吃瓜小能手',
    role: '资深用户',
    text: '每天打开每日大赛黑料网已经成为我的习惯，这里的爆料又快又准，从来没有让我失望过！',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20person%20portrait%2C%20casual%20modern%20style%2C%20warm%20natural%20lighting%2C%20friendly%20expression%2C%20clean%20minimalist%20background%20with%20soft%20bokeh%2C%20professional%20headshot%20photography&width=120&height=120&seq=testimonial-avatar-01&orientation=squarish',
  },
  {
    id: 't-2',
    name: '八卦研究员',
    role: '媒体从业者',
    text: '作为媒体人，这里的爆料深度和速度都是一流的。很多独家内容都是从这里首发，行业标杆！',
    avatar: 'https://readdy.ai/api/search-image?query=Professional%20Chinese%20media%20worker%20portrait%2C%20modern%20office%20style%2C%20warm%20studio%20lighting%2C%20confident%20expression%2C%20clean%20neutral%20background%2C%20editorial%20headshot%20photography&width=120&height=120&seq=testimonial-avatar-02&orientation=squarish',
  },
  {
    id: 't-3',
    name: '夜猫子吃瓜',
    role: '忠实粉丝',
    text: '半夜刷到更新是常态，这里的瓜又大又甜，熬夜也要看完！推荐给了身边所有朋友。',
    avatar: 'https://readdy.ai/api/search-image?query=Young%20Chinese%20woman%20portrait%2C%20casual%20night%20owl%20vibe%2C%20warm%20cozy%20lighting%2C%20excited%20expression%2C%20clean%20soft%20background%20with%20gentle%20bokeh%2C%20natural%20lifestyle%20photography&width=120&height=120&seq=testimonial-avatar-03&orientation=squarish',
  },
  {
    id: 't-4',
    name: '爆料小达人',
    role: '社区贡献者',
    text: '曾经在这里爆料过一次，编辑处理非常专业，保护了我的隐私的同时让真相得以传播。',
    avatar: 'https://readdy.ai/api/search-image?query=Chinese%20tech%20savvy%20young%20person%20portrait%2C%20modern%20stylish%20look%2C%20warm%20natural%20outdoor%20lighting%2C%20thoughtful%20expression%2C%20clean%20urban%20background%2C%20casual%20portrait%20photography&width=120&height=120&seq=testimonial-avatar-04&orientation=squarish',
  },
  {
    id: 't-5',
    name: '理性吃瓜人',
    role: '吃瓜群众',
    text: '能看到有态度的内容真的很开心，不是一味煽风点火，而是有理有据，这才是好媒体。',
    avatar: 'https://readdy.ai/api/search-image?query=Serious%20Chinese%20professional%20portrait%2C%20thoughtful%20expression%2C%20warm%20indoor%20lighting%2C%20clean%20minimalist%20background%2C%20editorial%20style%20headshot%20photography%20with%20soft%20shadows&width=120&height=120&seq=testimonial-avatar-05&orientation=squarish',
  },
];

export const faqData = [
  {
    question: '每日大赛黑料网的内容来源是什么？',
    answer: '我们的内容来自多个渠道，包括一线爆料人投稿、公开信息整理、社交媒体监测以及专业编辑团队的深度挖掘。所有内容均经过多轮核实，确保信息的真实性和可靠性。',
  },
  {
    question: '如何向平台投稿爆料？',
    answer: '你可以通过网站底部的"订阅爆料"入口提交线索，也可以在关于我们页面找到联系方式。我们承诺严格保护爆料人的隐私信息。',
  },
  {
    question: '网站多久更新一次内容？',
    answer: '我们坚持每日更新，重大事件发生时会在第一时间跟进报道。关注我们的社交媒体账号，不错过任何一个热点。',
  },
  {
    question: '看到错误信息如何反馈？',
    answer: '如果你发现任何不准确的内容，欢迎通过关于我们页面的联系方式与我们取得联系。我们会在核实后第一时间进行更正。',
  },
  {
    question: '每日大赛黑料网有APP吗？',
    answer: '目前我们正在紧锣密鼓地开发移动端APP，预计不久后就会与大家见面。现阶段你可以通过手机浏览器访问我们的网站，体验同样流畅。',
  },
];